import api from 'services/api';
import { requestGetAccessToken } from 'services/authServices';

export type ChannelType = 'EMAIL' | 'PHONE';

export type Channel = {
  contactId: string;
  contact: string;
  contactType: ChannelType;
  name?: string;
  isContactValidated: boolean;
};

export type ChannelsResponse = {
  userId: string;
  channels: Channel[];
};

type ApiError = {
  response?: {
    status?: number;
    data?:
      | { code?: string; message?: string }
      | Array<{ code?: string; message?: string }>;
  };
};

export const parseError = (
  error: unknown
): { code?: string; message?: string; status?: number } => {
  const { response } = (error ?? {}) as ApiError;
  const data = Array.isArray(response?.data)
    ? response?.data[0]
    : response?.data;

  return { code: data?.code, message: data?.message, status: response?.status };
};

const headers = async (): Promise<Record<string, string>> => ({
  'Content-Type': 'application/json',
  access_token: await requestGetAccessToken(),
});

export const getChannels = async (login: string): Promise<ChannelsResponse> => {
  const response = await api.post(
    'industrial/customer/v1/users/reset-password/channels',
    { login },
    { headers: await headers() }
  );

  return response.data;
};

export const sendCode = async (
  login: string,
  contactId: string
): Promise<void> => {
  await api.post(
    'industrial/customer/v1/users/reset-password',
    { login, contactId },
    { headers: await headers() }
  );
};

export const validateCode = async (
  userId: string,
  token: string
): Promise<void> => {
  await api.post(
    `industrial/customer/v1/users/${userId}/validations`,
    { token },
    { headers: await headers() }
  );
};

export const changePassword = async (
  userId: string,
  token: string,
  password: string
): Promise<void> => {
  const response = await api.patch(
    `industrial/customer/v1/users/${userId}`,
    { token, password, passwordConfirmation: password },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: process.env.REACT_APP_SIGNIN_AUTHORIZATION,
      },
    }
  );

  const mfaHash = response.headers['x-mfa-hash'];
  if (mfaHash) {
    localStorage.setItem('@UltragazEmpresarial:X-Mfa-Hash', mfaHash);
  }
};
